import type { MetricMap, MetricName, PerformanceRating } from '@/types';

import { METRIC_META } from '@/data/data';

export const getPerformanceRating = (
  metricName: MetricName,
  value: number
): PerformanceRating => {
  const metric = METRIC_META[metricName];
  if (!metric) return '有待改进' as PerformanceRating;

  if (value <= metric.good) {
    return '非常棒';
  } else if (value <= metric.ni) {
    return '有待改进';
  } else {
    return '较差';
  }
};

export const formatMetricValue = (
  metricName: MetricName,
  value: number
): string => {
  const metric = METRIC_META[metricName];
  if (!metric) return `${value}`;

  if (metric.unit === 'ms') {
    return `${value.toFixed(0)}ms`;
  } else {
    return `${value.toFixed(3)}`;
  }
};